import { createContext, useContext } from 'react';

/**
 * The workspace's enforced concurrency limit, for the cards and rows below a page
 * that read the workspace (spec 115, research R3).
 *
 * A context rather than a prop because the number is needed several components below
 * the aggregate, only to finish one sentence. `null` — no provider, or an older
 * service without the field — makes that sentence say "at its limit" without a number.
 */
export const WorkspaceConcurrencyContext = createContext<number | null>(null);

export function useWorkspaceConcurrencyLimit(): number | null {
  return useContext(WorkspaceConcurrencyContext);
}
